<div
    class="one"
    fxLayout="column"
    [formGroup]="MatterPropertyDetailsForm"
>
    <div
        fxLayout="row"
        fxLayoutAlign="start center"
        fxFlex="1 0 auto"
    >
        <mat-form-field
            appearance="outline"
            fxFlex="75"
            class="pr-1"
        >
            <mat-label>Title Ref(s) - Separate with commas</mat-label>
            <input
                matInput
                formControlName="LOTSTITLE"
                matTooltip="{{ toolTipList ? toolTipList.LOTSTITLE?.HOVER : '' }}"
                [matTooltipPosition]="toolTipPostion"
            />
            @if (testBool && toolTipList.LOTSTITLE) {
                <div class="tooltip-wrap">
                    <input
                        id="myInput"
                        readonly
                        disabled
                        value="{{ toolTipList ? toolTipList.LOTSTITLE.COPYVALUE : '' }}"
                    />
                    <mat-icon
                        (click)="
                            tooltipService.copyTooltipText(
                                toolTipList
                                    ? $safeNavigationMigration(toolTipList?.LOTSTITLE?.COPYVALUE)
                                    : ''
                            )
                        "
                    >
                        file_copy
                    </mat-icon>
                </div>
            }
        </mat-form-field>
        <div
            fxFlex="25"
            class="Split-Title"
        >
            <button
                matButton="filled"
                class="mat-accent"
                (click)="SplitTitleRefs()"
                [disabled]="isspiner"
            >
                @if (isspiner) {
                    <mat-spinner diameter="24"></mat-spinner>
                }
                Split Title Refs
            </button>
        </div>
    </div>
    <div
        fxLayout="row"
        fxLayoutAlign="start center"
        fxFlex="1 0 auto"
    >
        <div fxFlex="20">
            <mat-label>Volume(s)</mat-label>
        </div>
        <div fxFlex="20">
            <mat-label>Folio Id(s)</mat-label>
        </div>
        <div fxFlex="20">
            <mat-label>Lot(s)</mat-label>
        </div>
        <div fxFlex="20">
            <mat-label>Plan Type (s)</mat-label>
        </div>
        <div fxFlex="20">
            <mat-label>Plan No(s)</mat-label>
        </div>
    </div>
    <div
        fxLayout="row"
        fxLayoutAlign="start center"
        fxFlex="1 0 auto"
    >
        <mat-form-field
            appearance="outline"
            class="example"
            fxFlex="20"
            class="pr-1"
            [ngClass]="{
                'has-error': $safeNavigationMigration(errorWarningData.Error?.VOLUME),
                'has-warning': $safeNavigationMigration(errorWarningData.Warning?.VOLUME),
            }"
        >
            <input
                matInput
                matTooltip="{{ toolTipList ? toolTipList.VOLUME?.HOVER : '' }}"
                [matTooltipPosition]="toolTipPostion"
                formControlName="VOLUME"
            />
            @if (testBool && toolTipList.VOLUME) {
                <div class="tooltip-wrap">
                    <input
                        id="myInput"
                        readonly
                        disabled
                        value="{{ toolTipList ? toolTipList.VOLUME.COPYVALUE : '' }}"
                    />
                    <mat-icon
                        (click)="
                            tooltipService.copyTooltipText(
                                toolTipList
                                    ? $safeNavigationMigration(toolTipList?.VOLUME?.COPYVALUE)
                                    : ''
                            )
                        "
                    >
                        file_copy
                    </mat-icon>
                </div>
            }
        </mat-form-field>
        <mat-form-field
            appearance="outline"
            class="example"
            fxFlex="20"
            class="pr-1"
            [ngClass]="{
                'has-error': $safeNavigationMigration(errorWarningData.Error?.FOLIOID),
                'has-warning': $safeNavigationMigration(errorWarningData.Warning?.FOLIOID),
            }"
        >
            <input
                matInput
                matTooltip="{{ toolTipList ? toolTipList.FOLIOID?.HOVER : '' }}"
                [matTooltipPosition]="toolTipPostion"
                formControlName="FOLIOID"
            />
            @if (testBool && toolTipList.FOLIOID) {
                <div class="tooltip-wrap">
                    <input
                        id="myInput"
                        readonly
                        disabled
                        value="{{ toolTipList ? toolTipList.FOLIOID.COPYVALUE : '' }}"
                    />
                    <mat-icon
                        (click)="
                            tooltipService.copyTooltipText(
                                toolTipList
                                    ? $safeNavigationMigration(toolTipList?.FOLIOID?.COPYVALUE)
                                    : ''
                            )
                        "
                    >
                        file_copy
                    </mat-icon>
                </div>
            }
        </mat-form-field>
        <mat-form-field
            appearance="outline"
            class="example"
            fxFlex="20"
            class="pr-1"
            [ngClass]="{
                'has-error': $safeNavigationMigration(errorWarningData.Error?.LOTS),
                'has-warning': $safeNavigationMigration(errorWarningData.Warning?.LOTS),
            }"
        >
            <input
                matInput
                matTooltip="{{ toolTipList ? toolTipList.LOTS?.HOVER : '' }}"
                [matTooltipPosition]="toolTipPostion"
                formControlName="LOTS"
            />
            @if (testBool && toolTipList.LOTS) {
                <div class="tooltip-wrap">
                    <input
                        id="myInput"
                        readonly
                        disabled
                        value="{{ toolTipList ? toolTipList.LOTS.COPYVALUE : '' }}"
                    />
                    <mat-icon
                        (click)="
                            tooltipService.copyTooltipText(
                                toolTipList
                                    ? $safeNavigationMigration(toolTipList?.LOTS?.COPYVALUE)
                                    : ''
                            )
                        "
                    >
                        file_copy
                    </mat-icon>
                </div>
            }
        </mat-form-field>
        <mat-form-field
            appearance="outline"
            class="example"
            fxFlex="20"
            class="pr-1"
            [ngClass]="{
                'has-error': $safeNavigationMigration(errorWarningData.Error?.PLANTYPE),
                'has-warning': $safeNavigationMigration(errorWarningData.Warning?.PLANTYPE),
            }"
        >
            <input
                matInput
                matTooltip="{{ toolTipList ? toolTipList.PLANTYPE?.HOVER : '' }}"
                [matTooltipPosition]="toolTipPostion"
                formControlName="PLANTYPE"
            />
            @if (testBool && toolTipList.PLANTYPE) {
                <div class="tooltip-wrap">
                    <input
                        id="myInput"
                        readonly
                        disabled
                        value="{{ toolTipList ? toolTipList.PLANTYPE.COPYVALUE : '' }}"
                    />
                    <mat-icon
                        (click)="
                            tooltipService.copyTooltipText(
                                toolTipList
                                    ? $safeNavigationMigration(toolTipList?.PLANTYPE?.COPYVALUE)
                                    : ''
                            )
                        "
                    >
                        file_copy
                    </mat-icon>
                </div>
            }
        </mat-form-field>
        <mat-form-field
            appearance="outline"
            class="example"
            fxFlex="20"
            class="pr-1"
            [ngClass]="{
                'has-error': $safeNavigationMigration(errorWarningData.Error?.PLANNUMBER),
                'has-warning': $safeNavigationMigration(errorWarningData.Warning?.PLANNUMBER),
            }"
        >
            <input
                matInput
                matTooltip="{{ toolTipList ? toolTipList.PLANNUMBER?.HOVER : '' }}"
                [matTooltipPosition]="toolTipPostion"
                formControlName="PLANNUMBER"
            />
            @if (testBool && toolTipList.PLANNUMBER) {
                <div class="tooltip-wrap">
                    <input
                        id="myInput"
                        readonly
                        disabled
                        value="{{ toolTipList ? toolTipList.PLANNUMBER.COPYVALUE : '' }}"
                    />
                    <mat-icon
                        (click)="
                            tooltipService.copyTooltipText(
                                toolTipList
                                    ? $safeNavigationMigration(toolTipList?.PLANNUMBER?.COPYVALUE)
                                    : ''
                            )
                        "
                    >
                        file_copy
                    </mat-icon>
                </div>
            }
        </mat-form-field>
    </div>
    <div
        fxLayout="row"
        fxLayoutAlign="start center"
        fxFlex="1 0 auto"
    >
        <mat-form-field
            appearance="outline"
            class="example"
            fxFlex="20"
            class="pr-1"
            [ngClass]="{
                'has-error': $safeNavigationMigration(errorWarningData.Error?.VOLUME2),
                'has-warning': $safeNavigationMigration(errorWarningData.Warning?.VOLUME2),
            }"
        >
            <input
                matInput
                matTooltip="{{ toolTipList ? toolTipList.VOLUME2?.HOVER : '' }}"
                [matTooltipPosition]="toolTipPostion"
                formControlName="VOLUME2"
            />
            @if (testBool && toolTipList.VOLUME2) {
                <div class="tooltip-wrap">
                    <input
                        id="myInput"
                        readonly
                        disabled
                        value="{{ toolTipList ? toolTipList.VOLUME2.COPYVALUE : '' }}"
                    />
                    <mat-icon
                        (click)="
                            tooltipService.copyTooltipText(
                                toolTipList
                                    ? $safeNavigationMigration(toolTipList?.VOLUME2?.COPYVALUE)
                                    : ''
                            )
                        "
                    >
                        file_copy
                    </mat-icon>
                </div>
            }
        </mat-form-field>
        <mat-form-field
            appearance="outline"
            class="example"
            fxFlex="20"
            class="pr-1"
            [ngClass]="{
                'has-error': $safeNavigationMigration(errorWarningData.Error?.FOLIOID2),
                'has-warning': $safeNavigationMigration(errorWarningData.Warning?.FOLIOID2),
            }"
        >
            <input
                matInput
                matTooltip="{{ toolTipList ? toolTipList.FOLIOID2?.HOVER : '' }}"
                [matTooltipPosition]="toolTipPostion"
                formControlName="FOLIOID2"
            />
            @if (testBool && toolTipList.FOLIOID2) {
                <div class="tooltip-wrap">
                    <input
                        id="myInput"
                        readonly
                        disabled
                        value="{{ toolTipList ? toolTipList.FOLIOID2.COPYVALUE : '' }}"
                    />
                    <mat-icon
                        (click)="
                            tooltipService.copyTooltipText(
                                toolTipList
                                    ? $safeNavigationMigration(toolTipList?.FOLIOID2?.COPYVALUE)
                                    : ''
                            )
                        "
                    >
                        file_copy
                    </mat-icon>
                </div>
            }
        </mat-form-field>
        <mat-form-field
            appearance="outline"
            class="example"
            fxFlex="20"
            class="pr-1"
            [ngClass]="{
                'has-error': $safeNavigationMigration(errorWarningData.Error?.LOT2),
                'has-warning': $safeNavigationMigration(errorWarningData.Warning?.LOT2),
            }"
        >
            <input
                matInput
                matTooltip="{{ toolTipList ? toolTipList.LOT2?.HOVER : '' }}"
                [matTooltipPosition]="toolTipPostion"
                formControlName="LOT2"
            />
            @if (testBool && toolTipList.LOT2) {
                <div class="tooltip-wrap">
                    <input
                        id="myInput"
                        readonly
                        disabled
                        value="{{ toolTipList ? toolTipList.LOT2.COPYVALUE : '' }}"
                    />
                    <mat-icon
                        (click)="
                            tooltipService.copyTooltipText(
                                toolTipList
                                    ? $safeNavigationMigration(toolTipList?.LOT2?.COPYVALUE)
                                    : ''
                            )
                        "
                    >
                        file_copy
                    </mat-icon>
                </div>
            }
        </mat-form-field>
        <mat-form-field
            appearance="outline"
            class="example"
            fxFlex="20"
            class="pr-1"
            [ngClass]="{
                'has-error': $safeNavigationMigration(errorWarningData.Error?.PLANTYPE2),
                'has-warning': $safeNavigationMigration(errorWarningData.Warning?.PLANTYPE2),
            }"
        >
            <input
                matInput
                matTooltip="{{ toolTipList ? toolTipList.PLANTYPE2?.HOVER : '' }}"
                [matTooltipPosition]="toolTipPostion"
                formControlName="PLANTYPE2"
            />
            @if (testBool && toolTipList.PLANTYPE2) {
                <div class="tooltip-wrap">
                    <input
                        id="myInput"
                        readonly
                        disabled
                        value="{{ toolTipList ? toolTipList.PLANTYPE2.COPYVALUE : '' }}"
                    />
                    <mat-icon
                        (click)="
                            tooltipService.copyTooltipText(
                                toolTipList
                                    ? $safeNavigationMigration(toolTipList?.PLANTYPE2?.COPYVALUE)
                                    : ''
                            )
                        "
                    >
                        file_copy
                    </mat-icon>
                </div>
            }
        </mat-form-field>
        <mat-form-field
            appearance="outline"
            class="example"
            fxFlex="20"
            class="pr-1"
            [ngClass]="{
                'has-error': $safeNavigationMigration(errorWarningData.Error?.PLANNUMBER2),
                'has-warning': $safeNavigationMigration(errorWarningData.Warning?.PLANNUMBER2),
            }"
        >
            <input
                matInput
                matTooltip="{{ toolTipList ? toolTipList.PLANNUMBER2?.HOVER : '' }}"
                [matTooltipPosition]="toolTipPostion"
                formControlName="PLANNUMBER2"
            />
            @if (testBool && toolTipList.PLANNUMBER2) {
                <div class="tooltip-wrap">
                    <input
                        id="myInput"
                        readonly
                        disabled
                        value="{{ toolTipList ? toolTipList.PLANNUMBER2.COPYVALUE : '' }}"
                    />
                    <mat-icon
                        (click)="
                            tooltipService.copyTooltipText(
                                toolTipList
                                    ? $safeNavigationMigration(toolTipList?.PLANNUMBER2?.COPYVALUE)
                                    : ''
                            )
                        "
                    >
                        file_copy
                    </mat-icon>
                </div>
            }
        </mat-form-field>
    </div>
    <div
        fxLayout="row"
        fxLayoutAlign="start center"
        fxFlex="1 0 auto"
    >
        <mat-form-field
            appearance="outline"
            class="example"
            fxFlex="20"
            class="pr-1"
            [ngClass]="{
                'has-error': $safeNavigationMigration(errorWarningData.Error?.VOLUME3),
                'has-warning': $safeNavigationMigration(errorWarningData.Warning?.VOLUME3),
            }"
        >
            <input
                matInput
                matTooltip="{{ toolTipList ? toolTipList.VOLUME3?.HOVER : '' }}"
                [matTooltipPosition]="toolTipPostion"
                formControlName="VOLUME3"
            />
            @if (testBool && toolTipList.VOLUME3) {
                <div class="tooltip-wrap">
                    <input
                        id="myInput"
                        readonly
                        disabled
                        value="{{ toolTipList ? toolTipList.VOLUME3.COPYVALUE : '' }}"
                    />
                    <mat-icon
                        (click)="
                            tooltipService.copyTooltipText(
                                toolTipList
                                    ? $safeNavigationMigration(toolTipList?.VOLUME3?.COPYVALUE)
                                    : ''
                            )
                        "
                    >
                        file_copy
                    </mat-icon>
                </div>
            }
        </mat-form-field>
        <mat-form-field
            appearance="outline"
            class="example"
            fxFlex="20"
            class="pr-1"
            [ngClass]="{
                'has-error': $safeNavigationMigration(errorWarningData.Error?.FOLIOID3),
                'has-warning': $safeNavigationMigration(errorWarningData.Warning?.FOLIOID3),
            }"
        >
            <input
                matInput
                matTooltip="{{ toolTipList ? toolTipList.FOLIOID3?.HOVER : '' }}"
                [matTooltipPosition]="toolTipPostion"
                formControlName="FOLIOID3"
            />
            @if (testBool && toolTipList.FOLIOID3) {
                <div class="tooltip-wrap">
                    <input
                        id="myInput"
                        readonly
                        disabled
                        value="{{ toolTipList ? toolTipList.FOLIOID3.COPYVALUE : '' }}"
                    />
                    <mat-icon
                        (click)="
                            tooltipService.copyTooltipText(
                                toolTipList
                                    ? $safeNavigationMigration(toolTipList?.FOLIOID3?.COPYVALUE)
                                    : ''
                            )
                        "
                    >
                        file_copy
                    </mat-icon>
                </div>
            }
        </mat-form-field>
        <mat-form-field
            appearance="outline"
            class="example"
            fxFlex="20"
            class="pr-1"
            [ngClass]="{
                'has-error': $safeNavigationMigration(errorWarningData.Error?.LOT3),
                'has-warning': $safeNavigationMigration(errorWarningData.Warning?.LOT3),
            }"
        >
            <input
                matInput
                matTooltip="{{ toolTipList ? toolTipList.LOT3?.HOVER : '' }}"
                [matTooltipPosition]="toolTipPostion"
                formControlName="LOT3"
            />
            @if (testBool && toolTipList.LOT3) {
                <div class="tooltip-wrap">
                    <input
                        id="myInput"
                        readonly
                        disabled
                        value="{{ toolTipList ? toolTipList.LOT3.COPYVALUE : '' }}"
                    />
                    <mat-icon
                        (click)="
                            tooltipService.copyTooltipText(
                                toolTipList
                                    ? $safeNavigationMigration(toolTipList?.LOT3?.COPYVALUE)
                                    : ''
                            )
                        "
                    >
                        file_copy
                    </mat-icon>
                </div>
            }
        </mat-form-field>
        <mat-form-field
            appearance="outline"
            class="example"
            fxFlex="20"
            class="pr-1"
            [ngClass]="{
                'has-error': $safeNavigationMigration(errorWarningData.Error?.PLANTYPE3),
                'has-warning': $safeNavigationMigration(errorWarningData.Warning?.PLANTYPE3),
            }"
        >
            <input
                matInput
                matTooltip="{{ toolTipList ? toolTipList.PLANTYPE3?.HOVER : '' }}"
                [matTooltipPosition]="toolTipPostion"
                formControlName="PLANTYPE3"
            />
            @if (testBool && toolTipList.PLANTYPE3) {
                <div class="tooltip-wrap">
                    <input
                        id="myInput"
                        readonly
                        disabled
                        value="{{ toolTipList ? toolTipList.PLANTYPE3.COPYVALUE : '' }}"
                    />
                    <mat-icon
                        (click)="
                            tooltipService.copyTooltipText(
                                toolTipList
                                    ? $safeNavigationMigration(toolTipList?.PLANTYPE3?.COPYVALUE)
                                    : ''
                            )
                        "
                    >
                        file_copy
                    </mat-icon>
                </div>
            }
        </mat-form-field>
        <mat-form-field
            appearance="outline"
            class="example"
            fxFlex="20"
            class="pr-1"
            [ngClass]="{
                'has-error': $safeNavigationMigration(errorWarningData.Error?.PLANNUMBER3),
                'has-warning': $safeNavigationMigration(errorWarningData.Warning?.PLANNUMBER3),
            }"
        >
            <input
                matInput
                matTooltip="{{ toolTipList ? toolTipList.PLANNUMBER3?.HOVER : '' }}"
                [matTooltipPosition]="toolTipPostion"
                formControlName="PLANNUMBER3"
            />
            @if (testBool && toolTipList.PLANNUMBER3) {
                <div class="tooltip-wrap">
                    <input
                        id="myInput"
                        readonly
                        disabled
                        value="{{ toolTipList ? toolTipList.PLANNUMBER3.COPYVALUE : '' }}"
                    />
                    <mat-icon
                        (click)="
                            tooltipService.copyTooltipText(
                                toolTipList
                                    ? $safeNavigationMigration(toolTipList?.PLANNUMBER3?.COPYVALUE)
                                    : ''
                            )
                        "
                    >
                        file_copy
                    </mat-icon>
                </div>
            }
        </mat-form-field>
    </div>
    <div
        fxLayout="row"
        fxLayoutAlign="start center"
        fxFlex="1 0 auto"
    >
        <mat-form-field
            appearance="outline"
            class="example"
            fxFlex="20"
            class="pr-1"
            [ngClass]="{
                'has-error': $safeNavigationMigration(errorWarningData.Error?.VOLUME4),
                'has-warning': $safeNavigationMigration(errorWarningData.Warning?.VOLUME4),
            }"
        >
            <input
                matInput
                matTooltip="{{ toolTipList ? toolTipList.VOLUME4?.HOVER : '' }}"
                [matTooltipPosition]="toolTipPostion"
                formControlName="VOLUME4"
            />
            @if (testBool && toolTipList.VOLUME4) {
                <div class="tooltip-wrap">
                    <input
                        id="myInput"
                        readonly
                        disabled
                        value="{{ toolTipList ? toolTipList.VOLUME4.COPYVALUE : '' }}"
                    />
                    <mat-icon
                        (click)="
                            tooltipService.copyTooltipText(
                                toolTipList
                                    ? $safeNavigationMigration(toolTipList?.VOLUME4?.COPYVALUE)
                                    : ''
                            )
                        "
                    >
                        file_copy
                    </mat-icon>
                </div>
            }
        </mat-form-field>
        <mat-form-field
            appearance="outline"
            class="example"
            fxFlex="20"
            class="pr-1"
            [ngClass]="{
                'has-error': $safeNavigationMigration(errorWarningData.Error?.FOLIOID4),
                'has-warning': $safeNavigationMigration(errorWarningData.Warning?.FOLIOID4),
            }"
        >
            <input
                matInput
                matTooltip="{{ toolTipList ? toolTipList.FOLIOID4?.HOVER : '' }}"
                [matTooltipPosition]="toolTipPostion"
                formControlName="FOLIOID4"
            />
            @if (testBool && toolTipList.FOLIOID4) {
                <div class="tooltip-wrap">
                    <input
                        id="myInput"
                        readonly
                        disabled
                        value="{{ toolTipList ? toolTipList.FOLIOID4.COPYVALUE : '' }}"
                    />
                    <mat-icon
                        (click)="
                            tooltipService.copyTooltipText(
                                toolTipList
                                    ? $safeNavigationMigration(toolTipList?.FOLIOID4?.COPYVALUE)
                                    : ''
                            )
                        "
                    >
                        file_copy
                    </mat-icon>
                </div>
            }
        </mat-form-field>
        <mat-form-field
            appearance="outline"
            class="example"
            fxFlex="20"
            class="pr-1"
            [ngClass]="{
                'has-error': $safeNavigationMigration(errorWarningData.Error?.LOT4),
                'has-warning': $safeNavigationMigration(errorWarningData.Warning?.LOT4),
            }"
        >
            <input
                matInput
                matTooltip="{{ toolTipList ? toolTipList.LOT4?.HOVER : '' }}"
                [matTooltipPosition]="toolTipPostion"
                formControlName="LOT4"
            />
            @if (testBool && toolTipList.LOT4) {
                <div class="tooltip-wrap">
                    <input
                        id="myInput"
                        readonly
                        disabled
                        value="{{ toolTipList ? toolTipList.LOT4.COPYVALUE : '' }}"
                    />
                    <mat-icon
                        (click)="
                            tooltipService.copyTooltipText(
                                toolTipList
                                    ? $safeNavigationMigration(toolTipList?.LOT4?.COPYVALUE)
                                    : ''
                            )
                        "
                    >
                        file_copy
                    </mat-icon>
                </div>
            }
        </mat-form-field>
        <mat-form-field
            appearance="outline"
            class="example"
            fxFlex="20"
            class="pr-1"
            [ngClass]="{
                'has-error': $safeNavigationMigration(errorWarningData.Error?.PLANTYPE4),
                'has-warning': $safeNavigationMigration(errorWarningData.Warning?.PLANTYPE4),
            }"
        >
            <input
                matInput
                matTooltip="{{ toolTipList ? toolTipList.PLANTYPE4?.HOVER : '' }}"
                [matTooltipPosition]="toolTipPostion"
                formControlName="PLANTYPE4"
            />
            @if (testBool && toolTipList.PLANTYPE4) {
                <div class="tooltip-wrap">
                    <input
                        id="myInput"
                        readonly
                        disabled
                        value="{{ toolTipList ? toolTipList.PLANTYPE4.COPYVALUE : '' }}"
                    />
                    <mat-icon
                        (click)="
                            tooltipService.copyTooltipText(
                                toolTipList
                                    ? $safeNavigationMigration(toolTipList?.PLANTYPE4?.COPYVALUE)
                                    : ''
                            )
                        "
                    >
                        file_copy
                    </mat-icon>
                </div>
            }
        </mat-form-field>
        <mat-form-field
            appearance="outline"
            class="example"
            fxFlex="20"
            class="pr-1"
            [ngClass]="{
                'has-error': $safeNavigationMigration(errorWarningData.Error?.PLANNUMBER4),
                'has-warning': $safeNavigationMigration(errorWarningData.Warning?.PLANNUMBER4),
            }"
        >
            <input
                matInput
                matTooltip="{{ toolTipList ? toolTipList.PLANNUMBER4?.HOVER : '' }}"
                [matTooltipPosition]="toolTipPostion"
                formControlName="PLANNUMBER4"
            />
            @if (testBool && toolTipList.PLANNUMBER4) {
                <div class="tooltip-wrap">
                    <input
                        id="myInput"
                        readonly
                        disabled
                        value="{{ toolTipList ? toolTipList.PLANNUMBER4.COPYVALUE : '' }}"
                    />
                    <mat-icon
                        (click)="
                            tooltipService.copyTooltipText(
                                toolTipList
                                    ? $safeNavigationMigration(toolTipList?.PLANNUMBER4?.COPYVALUE)
                                    : ''
                            )
                        "
                    >
                        file_copy
                    </mat-icon>
                </div>
            }
        </mat-form-field>
    </div>
    <div
        fxLayout="row"
        fxLayoutAlign="start center"
        fxFlex="1 0 auto"
    >
        <mat-form-field
            appearance="outline"
            class="example"
            fxFlex="20"
            class="pr-1"
            [ngClass]="{
                'has-error': $safeNavigationMigration(errorWarningData.Error?.VOLUME5),
                'has-warning': $safeNavigationMigration(errorWarningData.Warning?.VOLUME5),
            }"
        >
            <input
                matInput
                matTooltip="{{ toolTipList ? toolTipList.VOLUME5?.HOVER : '' }}"
                [matTooltipPosition]="toolTipPostion"
                formControlName="VOLUME5"
            />
            @if (testBool && toolTipList.VOLUME5) {
                <div class="tooltip-wrap">
                    <input
                        id="myInput"
                        readonly
                        disabled
                        value="{{ toolTipList ? toolTipList.VOLUME5.COPYVALUE : '' }}"
                    />
                    <mat-icon
                        (click)="
                            tooltipService.copyTooltipText(
                                toolTipList
                                    ? $safeNavigationMigration(toolTipList?.VOLUME5?.COPYVALUE)
                                    : ''
                            )
                        "
                    >
                        file_copy
                    </mat-icon>
                </div>
            }
        </mat-form-field>
        <mat-form-field
            appearance="outline"
            class="example"
            fxFlex="20"
            class="pr-1"
            [ngClass]="{
                'has-error': $safeNavigationMigration(errorWarningData.Error?.FOLIOID5),
                'has-warning': $safeNavigationMigration(errorWarningData.Warning?.FOLIOID5),
            }"
        >
            <input
                matInput
                matTooltip="{{ toolTipList ? toolTipList.FOLIOID5?.HOVER : '' }}"
                [matTooltipPosition]="toolTipPostion"
                formControlName="FOLIOID5"
            />
            @if (testBool && toolTipList.FOLIOID5) {
                <div class="tooltip-wrap">
                    <input
                        id="myInput"
                        readonly
                        disabled
                        value="{{ toolTipList ? toolTipList.FOLIOID5.COPYVALUE : '' }}"
                    />
                    <mat-icon
                        (click)="
                            tooltipService.copyTooltipText(
                                toolTipList
                                    ? $safeNavigationMigration(toolTipList?.FOLIOID5?.COPYVALUE)
                                    : ''
                            )
                        "
                    >
                        file_copy
                    </mat-icon>
                </div>
            }
        </mat-form-field>
        <mat-form-field
            appearance="outline"
            class="example"
            fxFlex="20"
            class="pr-1"
            [ngClass]="{
                'has-error': $safeNavigationMigration(errorWarningData.Error?.LOT5),
                'has-warning': $safeNavigationMigration(errorWarningData.Warning?.LOT5),
            }"
        >
            <input
                matInput
                matTooltip="{{ toolTipList ? toolTipList.LOT5?.HOVER : '' }}"
                [matTooltipPosition]="toolTipPostion"
                formControlName="LOT5"
            />
            @if (testBool && toolTipList.LOT5) {
                <div class="tooltip-wrap">
                    <input
                        id="myInput"
                        readonly
                        disabled
                        value="{{ toolTipList ? toolTipList.LOT5.COPYVALUE : '' }}"
                    />
                    <mat-icon
                        (click)="
                            tooltipService.copyTooltipText(
                                toolTipList
                                    ? $safeNavigationMigration(toolTipList?.LOT5?.COPYVALUE)
                                    : ''
                            )
                        "
                    >
                        file_copy
                    </mat-icon>
                </div>
            }
        </mat-form-field>
        <mat-form-field
            appearance="outline"
            class="example"
            fxFlex="20"
            class="pr-1"
            [ngClass]="{
                'has-error': $safeNavigationMigration(errorWarningData.Error?.PLANTYPE5),
                'has-warning': $safeNavigationMigration(errorWarningData.Warning?.PLANTYPE5),
            }"
        >
            <input
                matInput
                matTooltip="{{ toolTipList ? toolTipList.PLANTYPE5?.HOVER : '' }}"
                [matTooltipPosition]="toolTipPostion"
                formControlName="PLANTYPE5"
            />
            @if (testBool && toolTipList.PLANTYPE5) {
                <div class="tooltip-wrap">
                    <input
                        id="myInput"
                        readonly
                        disabled
                        value="{{ toolTipList ? toolTipList.PLANTYPE5.COPYVALUE : '' }}"
                    />
                    <mat-icon
                        (click)="
                            tooltipService.copyTooltipText(
                                toolTipList
                                    ? $safeNavigationMigration(toolTipList?.PLANTYPE5?.COPYVALUE)
                                    : ''
                            )
                        "
                    >
                        file_copy
                    </mat-icon>
                </div>
            }
        </mat-form-field>
        <mat-form-field
            appearance="outline"
            class="example"
            fxFlex="20"
            class="pr-1"
            [ngClass]="{
                'has-error': $safeNavigationMigration(errorWarningData.Error?.PLANNUMBER5),
                'has-warning': $safeNavigationMigration(errorWarningData.Warning?.PLANNUMBER5),
            }"
        >
            <input
                matInput
                matTooltip="{{ toolTipList ? toolTipList.PLANNUMBER5?.HOVER : '' }}"
                [matTooltipPosition]="toolTipPostion"
                formControlName="PLANNUMBER5"
            />
            @if (testBool && toolTipList.PLANNUMBER5) {
                <div class="tooltip-wrap">
                    <input
                        id="myInput"
                        readonly
                        disabled
                        value="{{ toolTipList ? toolTipList.PLANNUMBER5.COPYVALUE : '' }}"
                    />
                    <mat-icon
                        (click)="
                            tooltipService.copyTooltipText(
                                toolTipList
                                    ? $safeNavigationMigration(toolTipList?.PLANNUMBER5?.COPYVALUE)
                                    : ''
                            )
                        "
                    >
                        file_copy
                    </mat-icon>
                </div>
            }
        </mat-form-field>
    </div>
    <div
        fxLayout="row"
        fxLayoutAlign="start center"
        fxFlex="1 0 auto"
    >
        <mat-form-field
            appearance="outline"
            class="example"
            fxFlex="25"
            class="pr-1"
            [ngClass]="{
                'has-error': $safeNavigationMigration(errorWarningData.Error?.LOTSECTION),
                'has-warning': $safeNavigationMigration(errorWarningData.Warning?.LOTSECTION),
            }"
        >
            <mat-label>Section</mat-label>
            <input
                matInput
                name="Section"
                matTooltip="{{ toolTipList ? toolTipList.LOTSECTION?.HOVER : '' }}"
                [matTooltipPosition]="toolTipPostion"
                formControlName="LOTSECTION"
            />
            @if (testBool && toolTipList.LOTSECTION) {
                <div class="tooltip-wrap">
                    <input
                        id="myInput"
                        readonly
                        disabled
                        value="{{ toolTipList ? toolTipList.LOTSECTION.COPYVALUE : '' }}"
                    />
                    <mat-icon
                        (click)="
                            tooltipService.copyTooltipText(
                                toolTipList
                                    ? $safeNavigationMigration(toolTipList?.LOTSECTION?.COPYVALUE)
                                    : ''
                            )
                        "
                    >
                        file_copy
                    </mat-icon>
                </div>
            }
        </mat-form-field>
        <mat-form-field
            appearance="outline"
            class="example"
            fxFlex="25"
            class="pr-1"
            [ngClass]="{
                'has-error': $safeNavigationMigration(errorWarningData.Error?.BLOCK),
                'has-warning': $safeNavigationMigration(errorWarningData.Warning?.BLOCK),
            }"
        >
            <mat-label>Block</mat-label>
            <input
                matInput
                name="Block"
                matTooltip="{{ toolTipList ? toolTipList.BLOCK?.HOVER : '' }}"
                [matTooltipPosition]="toolTipPostion"
                formControlName="BLOCK"
            />
            @if (testBool && toolTipList.BLOCK) {
                <div class="tooltip-wrap">
                    <input
                        id="myInput"
                        readonly
                        disabled
                        value="{{ toolTipList ? toolTipList.BLOCK.COPYVALUE : '' }}"
                    />
                    <mat-icon
                        (click)="
                            tooltipService.copyTooltipText(
                                toolTipList
                                    ? $safeNavigationMigration(toolTipList?.BLOCK?.COPYVALUE)
                                    : ''
                            )
                        "
                    >
                        file_copy
                    </mat-icon>
                </div>
            }
        </mat-form-field>
        <mat-form-field
            appearance="outline"
            class="example"
            fxFlex="25"
            class="pr-1"
            [ngClass]="{
                'has-error': $safeNavigationMigration(errorWarningData.Error?.STAGENUMBER),
                'has-warning': $safeNavigationMigration(errorWarningData.Warning?.STAGENUMBER),
            }"
        >
            <mat-label>Stage No</mat-label>
            <input
                matInput
                name="StageNo"
                matTooltip="{{ toolTipList ? toolTipList.STAGENUMBER?.HOVER : '' }}"
                [matTooltipPosition]="toolTipPostion"
                formControlName="STAGENUMBER"
            />
            @if (testBool && toolTipList.STAGENUMBER) {
                <div class="tooltip-wrap">
                    <input
                        id="myInput"
                        readonly
                        disabled
                        value="{{ toolTipList ? toolTipList.STAGENUMBER.COPYVALUE : '' }}"
                    />
                    <mat-icon
                        (click)="
                            tooltipService.copyTooltipText(
                                toolTipList
                                    ? $safeNavigationMigration(toolTipList?.STAGENUMBER?.COPYVALUE)
                                    : ''
                            )
                        "
                    >
                        file_copy
                    </mat-icon>
                </div>
            }
        </mat-form-field>
        <mat-form-field
            appearance="outline"
            fxFlex="25"
            class="pr-1"
            [ngClass]="{
                'has-error': $safeNavigationMigration(errorWarningData.Error?.REDEVELOPMENTNUMBER),
                'has-warning': $safeNavigationMigration(
                    errorWarningData.Warning?.REDEVELOPMENTNUMBER
                ),
            }"
        >
            <mat-label>Redevelopment No</mat-label>
            <input
                name="RedevelopmentNo"
                matInput
                matTooltip="{{ toolTipList ? toolTipList.REDEVELOPMENTNUMBER?.HOVER : '' }}"
                [matTooltipPosition]="toolTipPostion"
                formControlName="REDEVELOPMENTNUMBER"
            />
            @if (testBool && toolTipList.REDEVELOPMENTNUMBER) {
                <div class="tooltip-wrap">
                    <input
                        id="myInput"
                        readonly
                        disabled
                        value="{{ toolTipList ? toolTipList.REDEVELOPMENTNUMBER.COPYVALUE : '' }}"
                    />
                    <mat-icon
                        (click)="
                            tooltipService.copyTooltipText(
                                toolTipList
                                    ? $safeNavigationMigration(
                                          toolTipList?.REDEVELOPMENTNUMBER?.COPYVALUE
                                      )
                                    : ''
                            )
                        "
                    >
                        file_copy
                    </mat-icon>
                </div>
            }
        </mat-form-field>
    </div>
</div>
